import 'core-js/actual/array/find-last-index';

export default defineNuxtPlugin(() => {});
